import { render } from "./FaqArea.vue?vue&type=template&id=bffd656c"
import script from "./FaqArea.vue?vue&type=script&lang=js"
export * from "./FaqArea.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Asistenca\\old-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__